import React, {useEffect} from 'react';
import {onBlankLayout} from 'store/slices/themeSlice';
import {useDispatch} from 'react-redux';
import PermissionHidden from "../components/permissions/PermissionHidden";
import {usePageCache} from "../mobile/components/PageCache";
import {KeepAlive} from "react-activation";
import {MOBILE_PREFIX_PATH} from "../configs/AppConfig";

const AppRoute = ({component: Component,path, routeKey, blankLayout, ...props}) => {

    const dispatch = useDispatch()
    const pageCache=usePageCache()

    /*
    useEffect(() => {
        const isBlank = blankLayout ? true : false
        dispatch(onBlankLayout(isBlank))

    }, [blankLayout])

     */

    if(path.startsWith(MOBILE_PREFIX_PATH)){
        return(
            <KeepAlive name={pageCache.key}>
                <Component {...props} />
            </KeepAlive>
        )
    }

    return (
        <Component {...props} />
    )
}

export default AppRoute
